import PropTypes from 'prop-types';
import { getConfig } from '../config.js';

export default async function apiServicewt(quary) {
	//const webLink = process.env.REACT_APP_WEB_LINK;
	const webLink = getConfig().REACT_APP_WEB_LINK;
	const result = await fetch(webLink, {
		method: 'post',
		headers: {
			'Content-Type': 'application/json',
			Accept: 'application/json',
		},
		body: JSON.stringify(quary),
	});
	const responce = await result.json();
	if (responce.type === 'error') {
		// localStorage.removeItem('user-auth');
		// navigate('/');
	}
	return responce;
}

apiServicewt.propTypes = {
	quary: PropTypes.isRequired,
};
